import { render } from "./DbServersSubComponent.vue?vue&type=template&id=672f3c8e"
import script from "./DbServersSubComponent.vue?vue&type=script&lang=js"
export * from "./DbServersSubComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__